import { useEffect, useState } from 'react';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { RESTAURANT_ID } from '../constants';
import { logAudit } from '../auditLog';
import { Icon, Modal, Switch, useToast } from '../ui';

export const WEBSITE = 'https://yedise.com';

// Restoranı tek tıkla aç/kapat (restaurants/{id}.isOpen).
export function RestaurantStatus() {
  const toast = useToast();
  const [isOpen, setIsOpen] = useState(null);
  const [confirmClose, setConfirmClose] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => onSnapshot(doc(db, 'restaurants', RESTAURANT_ID), (s) => setIsOpen(s.data()?.isOpen === true)), []);

  const setOpen = async (value) => {
    setBusy(true);
    try {
      await updateDoc(doc(db, 'restaurants', RESTAURANT_ID), { isOpen: value });
      logAudit('restaurant_open_changed', RESTAURANT_ID, { isOpen: value });
      toast(value ? 'Restoran açıldı, sipariş alınıyor.' : 'Restoran kapatıldı, yeni sipariş alınmıyor.', 'ok');
    } catch {
      toast('Durum değiştirilemedi, tekrar deneyin.', 'error');
    }
    setBusy(false);
    setConfirmClose(false);
  };

  if (isOpen === null) return null;
  return (
    <>
      <div className={`k-status ${isOpen ? 'is-open' : 'is-closed'}`}>
        <span className="dot" />
        <span>{isOpen ? 'Sipariş alıyor' : 'Kapalı'}</span>
        <Switch
          checked={isOpen} disabled={busy} title={isOpen ? 'Restoranı kapat' : 'Restoranı aç'}
          onChange={(v) => (v ? setOpen(true) : setConfirmClose(true))}
        />
      </div>
      {confirmClose && (
        <Modal
          title="Restoranı kapat"
          onClose={() => setConfirmClose(false)}
          width={420}
          footer={(
            <>
              <button type="button" className="k-btn k-btn-secondary" onClick={() => setConfirmClose(false)}>Vazgeç</button>
              <button type="button" className="k-btn k-btn-danger-solid" disabled={busy} onClick={() => setOpen(false)}>Kapat</button>
            </>
          )}
        >
          Restoran kapatıldığında uygulama ve web sitesinden <strong>yeni sipariş alınmaz</strong>. Mevcut siparişler etkilenmez.
        </Modal>
      )}
    </>
  );
}

export default function TopBar({ title, onMenu }) {
  return (
    <header className="k-topbar">
      <button type="button" className="k-icon-btn k-menu-btn" onClick={onMenu} aria-label="Menüyü aç"><Icon name="menu" size={20} /></button>
      <div>
        <div className="k-topbar-title">{title}</div>
      </div>
      <div className="k-topbar-spacer" />
    </header>
  );
}
